import styles from "./CapacityDailyOverview.module.scss";
import { DaySummaryPanel } from "./DaySummaryPanel/DaySummaryPanel";
import {
  useCapacityDayBreakdown,
  useCapacityDaySummary,
  type DayBreakdownData,
} from "@/api/Capacity";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { deducedError } from "@/Utils/ErrorUtils";
import { t } from "@lingui/core/macro";
import { DayBreakdownPanel } from "./DayBreakdownPanel/DayBreakdownPanel";
import { useEnabledCompetences } from "@/api/Shifts";

export const CapacityDailyOverview = ({ date }: { date: Date }) => {
  const {
    data: daySummaryData,
    isPending: isDaySummaryPending,
    isError: isDaySummaryError,
    error: daySummaryError,
  } = useCapacityDaySummary(date);

  const {
    data: dayBreakdownData,
    isPending: isDayBreakdownPending,
    isError: isDayBreakdownError,
    error: dayBreakdownError,
  } = useCapacityDayBreakdown(date);

  const {
    data: enabledCompetences,
    isPending: isEnabledCompetencesPending,
    isError: isEnabledCompetencesError,
    error: enabledCompetencesError,
  } = useEnabledCompetences();

  if (
    isDaySummaryPending ||
    isDayBreakdownPending ||
    isEnabledCompetencesPending
  ) {
    return <Loading padding={24} message={t`Hämtar kapacitetsöversikt`} />;
  }
  if (isDaySummaryError || isDayBreakdownError || isEnabledCompetencesError) {
    return (
      <ErrorMessage
        padding={24}
        message={`${t`Kunde inte hämta kapacitetsöversikt`}. ${deducedError(daySummaryError || dayBreakdownError || enabledCompetencesError)}`}
      />
    );
  }

  // Only show data for competences that the site uses
  const enabledCompetenceSet = new Set(enabledCompetences);
  const enabledDayBreakdownData = dayBreakdownData.filter(
    ({ competence }: DayBreakdownData) => enabledCompetenceSet.has(competence),
  );

  return (
    <div className={styles.capacityDailyOverview}>
      <div className={styles.content}>
        <div className={styles.daySummaryPanel}>
          <DaySummaryPanel daySummaryData={daySummaryData} />
        </div>
        <div className={styles.breakdownSection}>
          <DayBreakdownPanel dayBreakdownData={enabledDayBreakdownData} />
        </div>
      </div>
    </div>
  );
};
